<div class="title-container">
    <div class="subtitle subtitle-smaller">{{ title }}</div>
    <div class="title bold">
        {{ "graph.exhaust.title.deviation" | translate }}
        :
        <span class="highlighted-text">{{
            averageChannelValue ? averageChannelValue : 0
        }}</span>
    </div>
    <div class="subtitle subtitle-smaller">
        {{ "graph.exhaust.title.average" | translate }}
        <span class="highlighted-text" style="padding-left: 8px"
            >{{ averageChannel.fcuData.fcuChannelId }}&nbsp;
            {{ averageChannel.opsData.name }}</span
        >
    </div>
</div>
<div
    echarts
    [options]="echartsOptions"
    [extentions]="echartsExtentions"
    (chartInit)="onChartInit($event)"
></div>
